import { config } from '@/config/environment';
import { ClientAnalyticsEventType } from '../constants';

export const useTrackEventsAnalytics = () => {
  const fireEvent = (event: ClientAnalyticsEventType, properties: Record<string, string>) => {
    if (config.segmentKey && typeof (window as any).analytics !== 'undefined' && event) {
      return (window as any).analytics.track(event, properties);
    }
  };
  return { fireEvent };
};
